import { useMutation, useQueryClient } from '@tanstack/react-query';
import { teamsService } from '../services/teamsService';

/**
 * Hook to add user (member) to team
 */
export const useAddTeamUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ teamId, userId }: { teamId: string; userId: string }) =>
      teamsService.addUserToTeam({
        teamId,
        userId,
        role: 'member',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};

/**
 * Hook to remove user (member) from team
 */
export const useRemoveTeamUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ teamId, userId }: { teamId: string; userId: string }) =>
      teamsService.removeUserFromTeam(teamId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
  });
};
